import { render, staticRenderFns } from "./_deviceType.vue?vue&type=template&id=38174bb9&scoped=true"
import script from "./_deviceType.vue?vue&type=script&lang=js"
export * from "./_deviceType.vue?vue&type=script&lang=js"
import style0 from "./_deviceType.vue?vue&type=style&index=0&id=38174bb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38174bb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38174bb9')) {
      api.createRecord('38174bb9', component.options)
    } else {
      api.reload('38174bb9', component.options)
    }
    module.hot.accept("./_deviceType.vue?vue&type=template&id=38174bb9&scoped=true", function () {
      api.rerender('38174bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/_deviceType.vue"
export default component.exports